<template>
  <div>
    <!-- 第一部分：输入框、按钮 -->
    <div style="margin-bottom: 20px;float:left">
      <el-input v-model="search" placeholder="请输入定向包名称" style="width: 200px; margin-right: 10px;" />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button type="success" @click="openDialog()">添加定向包</el-button>
    </div>

    <!-- 第二部分：表格 -->
    <el-table :data="filteredList" style="width: 100%">
      <el-table-column prop="directpkgname" label="定向包名称" />
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="openDialog(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form :model="form" label-width="120px">
        <!-- 定向包名称 -->
        <el-form-item label="定向包名称" style="margin-bottom:28px; transition:all 0.3s;">
          <el-input
            v-model="form.directpkgname"
            placeholder="请输入定向包名称"
            clearable
            style="border-radius:8px; height:46px;">
          </el-input>
        </el-form-item>
        <el-form-item label="地域定向代码" style="margin-bottom:28px; transition:all 0.3s;">
          <el-input
            v-model="form.area"
            placeholder="请输入地域定向代码"
            clearable
            style="border-radius:8px; height:46px;">
          </el-input>
        </el-form-item>
        <div style="height:1px; background:linear-gradient(to right, transparent, #ecf0f1, transparent); margin:25px 0;"></div>

        <!-- 性别选择 -->
        <el-form-item label="性别" style="margin-bottom:28px; transition:all 0.3s;">
          <el-radio-group v-model="form.sex" style="display:flex; flex-wrap:wrap;">
            <el-radio-button label="男" style="transition:all 0.2s ease;">
              <span style="border-radius:8px !important;  transition:all 0.2s;">男</span>
            </el-radio-button>
            <el-radio-button label="女" style="transition:all 0.2s ease;">
              <span style="border-radius:8px !important;transition:all 0.2s;">女</span>
            </el-radio-button>
            <el-radio-button label="不限" style="transition:all 0.2s ease;">
              <span style="border-radius:8px !important;  transition:all 0.2s;">不限</span>
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <div style="height:1px; background:linear-gradient(to right, transparent, #ecf0f1, transparent); margin:25px 0;"></div>

        <!-- 年龄选择 -->
        <el-form-item label="年龄(不选即不限)" style="margin-bottom:28px; transition:all 0.3s;">

          <el-checkbox-group v-model="form.age" style="display:flex; flex-wrap:wrap;">
            <el-checkbox-button
              v-for="(item, i) in ages"
              :label="item.id"
              :key="item.id"
              style="transition:all 0.2s ease;">
              <span style="   transition:all 0.2s;">
                {{ item.value }}
              </span>
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>

        <div style="height:1px; background:linear-gradient(to right, transparent, #ecf0f1, transparent); margin:25px 0;"></div>

        <!-- 安卓版本 -->
        <el-form-item label="安卓版本" style="margin-bottom:28px; transition:all 0.3s; text-align: left;">
          <el-radio-group v-model="form.androidVersionStatus">
            <el-radio-button :label="0">不限</el-radio-button>
            <el-radio-button :label="1">设置</el-radio-button>
          </el-radio-group>

          <transition name="el-zoom-in-top">
            <div v-if="form.androidVersionStatus == 1" class="checkbox-section">
              <div class="select-all-row">
                <el-checkbox :indeterminate="form.isIndeterminateVersion" v-model="form.checkAllVersion"
                  @change="handleCheckAllVersionChange">
                  全选
                </el-checkbox>
                <span class="select-count">
                  已选择 {{ form.selectedVersions.length }}/{{ androidVersions.length }} 个版本
                </span>
              </div>

              <el-alert v-if="form.checkAllVersion" title="提示：全选所有安卓版本与「不限」是不同的。全选会传入所有版本 ID，不限则不传此参数。"
                type="warning" :closable="false" show-icon style="margin: 8px 0;">
              </el-alert>

              <el-checkbox-group v-model="form.selectedVersions" @change="handleVersionChange">
                <el-checkbox v-for="(version, index) in androidVersions" :key="version.value"
                  :label="version.value">
                  {{ version.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </transition>
        </el-form-item>

        <div style="height:1px; background:linear-gradient(to right, transparent, #ecf0f1, transparent); margin:25px 0;"></div>

        <!-- 购机价格 -->
        <el-form-item label="购机价格" style="margin-bottom:28px; transition:all 0.3s; text-align: left;">
          <el-radio-group v-model="form.phonePriceStatus">
            <el-radio-button :label="0">不限</el-radio-button>
            <el-radio-button :label="1">设置</el-radio-button>
          </el-radio-group>

          <transition name="el-zoom-in-top">
            <div v-if="form.phonePriceStatus == 1" class="checkbox-section">
              <div class="select-all-row">
                <el-checkbox :indeterminate="form.isIndeterminatePrice" v-model="form.checkAllPrice"
                  @change="handleCheckAllPriceChange">
                  全选
                </el-checkbox>
                <span class="select-count">
                  已选择 {{ form.selectedPrices.length }}/{{ priceRanges.length }} 个价格区间
                </span>
              </div>

              <el-alert v-if="form.checkAllPrice" title="提示：全选所有价格区间与「不限」是不同的。全选会传入所有价格 ID，不限则不传此参数。"
                type="warning" :closable="false" show-icon style="margin: 8px 0;">
              </el-alert>

              <el-checkbox-group v-model="form.selectedPrices" @change="handlePriceChange">
                <el-checkbox v-for="(priceRange, index) in priceRanges" :key="priceRange.value"
                  :label="priceRange.value">
                  {{ priceRange.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </transition>
        </el-form-item>

        <el-form-item label="手机系列" style="text-align: left;" prop="number2">
                      <el-radio-group v-model="form.phoneSeriesstatus">
                          <el-radio-button :label="0">不限</el-radio-button>
                          <el-radio-button :label="1">设置</el-radio-button>
                      </el-radio-group>

                      <transition name="el-zoom-in-top">
                        <div v-if="form.phoneSeriesstatus==1" class="checkbox-section">
                          <div class="select-all-row">
                              <el-checkbox
                                  :indeterminate="form.isIndeterminate"
                                  v-model="form.checkAll"
                                  @change="handleCheckAllChange"
                              >
                                  全选
                              </el-checkbox>
                              <span class="select-count">
                                已选择 {{ form.phoneSeriesSSelect.length }}/{{ phoneSerieslist.length }} 个系列
                              </span>
                          </div>

                          <el-alert v-if="form.checkAll" title="提示：全选所有机型与「不限」是不同的。全选会传入所有机型 ID，不限则不传此参数。"
                            type="warning" :closable="false" show-icon style="margin: 8px 0;">
                          </el-alert>

                          <el-checkbox-group v-model="form.phoneSeriesSSelect" @change="handlePhoneSeriesChange">
                              <el-checkbox v-for="item in phoneSerieslist" :key="item.id"
                                  :label="item.id">
                                  {{ item.name }}
                              </el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </transition>
                  </el-form-item>





<!--        <div style="margin-top:30px; display:flex; justify-content:center; gap:15px;">-->
<!--          <el-button type="primary" style="padding:12px 30px; border-radius:8px; font-weight:600; transition:all 0.3s; letter-spacing:0.5px; background:linear-gradient(to right, #3498db, #2ecc71); border:none; color:white;">-->
<!--            保存设置-->
<!--          </el-button>-->
<!--          <el-button style="padding:12px 30px; border-radius:8px; font-weight:600; transition:all 0.3s; letter-spacing:0.5px; background:#f8f9fa; color:#7f8c8d; border:1px solid #eaeaea;">-->
<!--            取消-->
<!--          </el-button>-->
<!--        </div>-->
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import aixos from "core-js/internals/queue";

export default {
  data() {
    return {
      search: '',
      ages:[
        {
          id: 25,
          value: '0-17岁'
        },
        {
          id: 26,
          value: '18-24岁'
        },
        {
          id: 27,
          value: '25-29岁'
        },
        {
          id: 28,
          value: '30-39岁'
        },
        {
          id: 29,
          value: '40-49岁'
        },
        {
          id: 30,
          value: '50岁及以上'
        },
      ],

      priceRanges: [
        { label: '>4500', value: 1530022 },
        { label: '4000~4500', value: 1530021 },
        { label: '3500~4000', value: 1530020 },
        { label: '3000~3500', value: 1530019 },
        { label: '2500~3000', value: 1530018 },
        { label: '2000~2500', value: 1530017 },
        { label: '1500~2000', value: 1530016 },
        { label: '1000~1500', value: 1530015 },
        { label: '0~1000', value: 1530014 }
      ],
      // 默认勾选所有购机价格区间ID

      // 定义安卓版本和对应的值
      androidVersions: [
        { label: '安卓4及以下', value: 1650003 },
        { label: '安卓5', value: 1650004 },
        { label: '安卓6', value: 1650005 },
        { label: '安卓7', value: 1650006 },
        { label: '安卓8', value: 1650007 },
        { label: '安卓9', value: 1650008 },
        { label: '安卓10', value: 1650001 },
        { label: '安卓11', value: 1650002 },
        { label: '安卓12', value: 1650009 },
        { label: '安卓13', value: 1650010 },
        { label: '安卓14', value: 1650011 },
        { label: '安卓15', value:  1650012 },
        { label: '安卓16及以上', value:  1650013 }
      ],
      // 默认勾选所有的安卓版本值
      androidVersionSetList: [],
      phonePriceSetList: [],
      list: [

      ],
      dialogVisible: false,
      dialogTitle: '添加定向包',
      form: {
        directpkgname: '',
        area: '',
        sex: '不限',
        age: [],
        selectedVersions: [1650001, 1650002, 1650003, 1650004, 1650005, 1650006, 1650007, 1650008, 1650009, 1650010, 1650011,1650012,1650013],
        selectedPrices: [1530014, 1530022, 1530021, 1530020, 1530019,
          1530018, 1530017, 1530016, 1530015],
        checkAll: false,
        isIndeterminate: false,
        phoneSeriesSSelect:[],
        phoneSeriesstatus:0,
        // 安卓版本状态
        androidVersionStatus: 1, // 默认设置
        checkAllVersion: true,
        isIndeterminateVersion: false,
        // 购机价格状态
        phonePriceStatus: 1, // 默认设置
        checkAllPrice: true,
        isIndeterminatePrice: false,
      },
      editIndex: null,
      phoneSerieslist : [
          { id: 1530002, name: "i系列" },
          { id: 1530001, name: "E系列" },
          { id: 1530003, name: "K系列" },
          { id: 1530004, name: "NEX系列" },
          { id: 1530005, name: "S系列" },
          { id: 1530006, name: "V系列" },
          { id: 1530007, name: "Y系列" },
          { id: 1530008, name: "Z系列" },
          { id: 1530009, name: "iQOO系列" },
          { id: 1530010, name: "X系列" },
          { id: 1530011, name: "Xplay系列" },
          { id: 1530012, name: "U系列" }
      ],
    }
  },
  computed: {
    filteredList() {
      if (!this.search) return this.list
      return this.list.filter(item => item.directpkgname.includes(this.search))
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    updateCheckAllStatus() {
        const totalCount = this.phoneSerieslist.length;
        const selectedCount = this.form.phoneSeriesSSelect.length;
        
        this.form.checkAll = selectedCount === totalCount;
        this.form.isIndeterminate = selectedCount > 0 && selectedCount < totalCount;
    },
    handleCheckAllChange(val) {
        if (val) {
            // 全选
            this.form.phoneSeriesSSelect = this.phoneSerieslist.map(item => item.id);
        } else {
            // 全不选
            this.form.phoneSeriesSSelect = [];
        }
        this.form.isIndeterminate = false;
    },
    
    // 复选框变化时更新全选状态
    handlePhoneSeriesChange(selectedIds) {
        const totalCount = this.phoneSerieslist.length;
        const selectedCount = selectedIds.length;

        this.form.checkAll = selectedCount === totalCount;
        this.form.isIndeterminate = selectedCount > 0 && selectedCount < totalCount;

        console.log('选中的系列ID:', selectedIds);
    },

    // 安卓版本全选
    handleCheckAllVersionChange(val) {
      if (val) {
        this.form.selectedVersions = this.androidVersions.map(item => item.value);
      } else {
        this.form.selectedVersions = [];
      }
      this.form.isIndeterminateVersion = false;
    },

    // 安卓版本复选框变化
    handleVersionChange(selectedValues) {
      const totalCount = this.androidVersions.length;
      const selectedCount = selectedValues.length;
      this.form.checkAllVersion = selectedCount === totalCount;
      this.form.isIndeterminateVersion = selectedCount > 0 && selectedCount < totalCount;
    },

    // 购机价格全选
    handleCheckAllPriceChange(val) {
      if (val) {
        this.form.selectedPrices = this.priceRanges.map(item => item.value);
      } else {
        this.form.selectedPrices = [];
      }
      this.form.isIndeterminatePrice = false;
    },

    // 购机价格复选框变化
    handlePriceChange(selectedValues) {
      const totalCount = this.priceRanges.length;
      const selectedCount = selectedValues.length;
      this.form.checkAllPrice = selectedCount === totalCount;
      this.form.isIndeterminatePrice = selectedCount > 0 && selectedCount < totalCount;
    },

    handleSearch() {
      // 这里只做本地过滤，实际可根据需求请求接口

      this.$axios.get('https://control.zjwec.cn/api/directpkgs/getByKhname?khname=' + this.search).then(response => {
        if (response.data) {
          this.list = response.data
        } else {
          this.$message.error('查询失败，请稍后重试')
        }
      })
    },
    openDialog(row) {
      console.log(row)


      if (row !== undefined) {

        this.form.id = row.id
        this.form.directpkgname = row.directpkgname
        this.form.area = row.regionList
        this.form.sex = row.sex
        this.form.age = JSON.parse(row.ageList)
        this.form.selectedVersions = JSON.parse(row.androidList)
        this.form.selectedPrices = JSON.parse(row.phonepriceList)

        // 设置安卓版本状态
        this.form.androidVersionStatus = this.form.selectedVersions.length > 0 ? 1 : 0;
        this.form.checkAllVersion = this.form.selectedVersions.length === this.androidVersions.length;
        this.form.isIndeterminateVersion = this.form.selectedVersions.length > 0 && this.form.selectedVersions.length < this.androidVersions.length;

        // 设置购机价格状态
        this.form.phonePriceStatus = this.form.selectedPrices.length > 0 ? 1 : 0;
        this.form.checkAllPrice = this.form.selectedPrices.length === this.priceRanges.length;
        this.form.isIndeterminatePrice = this.form.selectedPrices.length > 0 && this.form.selectedPrices.length < this.priceRanges.length;

        if(row.phoneseriesList){
          let a=JSON.parse(row.phoneseriesList)
          if(a.length>0){
            this.form.phoneSeriesstatus=1
            this.form.phoneSeriesSSelect = JSON.parse(row.phoneseriesList)
            this.updateCheckAllStatus()
          }else{
            this.form.phoneSeriesstatus=0
          }

        }

      } else {
        this.form.checkAll=false
        this.form.isIndeterminate=false
        this.form.phoneSeriesSSelect=[]
        this.form.phoneSeriesstatus=0
        this.form.directpkgname = ''
        this.form.area = ''

        // 重置安卓版本状态
        this.form.androidVersionStatus = 1;
        this.form.selectedVersions = [1650001, 1650002, 1650003, 1650004, 1650005, 1650006, 1650007, 1650008, 1650009, 1650010, 1650011, 1650012, 1650013];
        this.form.checkAllVersion = true;
        this.form.isIndeterminateVersion = false;

        // 重置购机价格状态
        this.form.phonePriceStatus = 1;
        this.form.selectedPrices = [1530014, 1530022, 1530021, 1530020, 1530019, 1530018, 1530017, 1530016, 1530015];
        this.form.checkAllPrice = true;
        this.form.isIndeterminatePrice = false;
      }
      this.dialogVisible = true
    },
    handleSave() {

      if (!this.form.directpkgname) {
        this.$message.error('定向包名称不能为空')
        return
      }
      if(this.form.area === '') {
        this.$message.error('地域定向不能为空')
        return
      }

      console.log(this.form)

      // 根据状态变量决定保存的数据
      const androidList = this.form.androidVersionStatus === 1 ? this.form.selectedVersions : [];
      const phonepriceList = this.form.phonePriceStatus === 1 ? this.form.selectedPrices : [];
      const phoneseriesList = this.form.phoneSeriesstatus === 1 ? this.form.phoneSeriesSSelect : [];

      if (this.form.id>0) {
        let obj={
          id: this.form.id,
          directpkgname: this.form.directpkgname,
          regionList: this.form.area,
          sex:this.form.sex,
          ageList:JSON.stringify(this.form.age),
          androidList:JSON.stringify(androidList),
          phonepriceList:JSON.stringify(phonepriceList),
          phoneseriesList:JSON.stringify(phoneseriesList)
        }
        this.$axios.put('https://control.zjwec.cn/api/directpkgs/update', {
          ...obj
        }).then(response => {
          if (response.data === true){
            this.$message.success('修改成功')
            this.handleSearch()
          } else {
            this.$message.error('保存失败，请稍后重试')
          }
        })
      }else{
        let obj={
          directpkgname: this.form.directpkgname,
          regionList: this.form.area,
          sex:this.form.sex,
          ageList:JSON.stringify(this.form.age),
          androidList:JSON.stringify(androidList),
          phonepriceList:JSON.stringify(phonepriceList),
          phoneseriesList:JSON.stringify(phoneseriesList)
        }
        this.$axios.post('https://control.zjwec.cn/api/directpkgs/create', {
         ...obj
        }).then(response => {
          if (response.data === true){
            this.$message.success('保存成功')
            this.handleSearch()
          } else {
            this.$message.error('保存失败，请稍后重试')
          }
        })
      }


      this.dialogVisible = false
    },
    handleDelete(index) {
      this.$axios.get('https://control.zjwec.cn/api/directpkgs/delete?id=' + index).then(response => {
        if (response.data === true) {
          this.$message.success('删除成功')
          this.handleSearch()
        } else {
          this.$message.error('删除失败，请联系下管理员')
        }
      })

    }
  },
  

}
</script>

<style scoped>
.checkbox-section {
  margin-top: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 15px;
  background-color: #fafafa;
}

.select-all-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.select-all-row .el-checkbox {
  font-weight: bold;
}

.select-count {
  font-size: 12px;
  color: #909399;
  background-color: #ecf5ff;
  padding: 2px 8px;
  border-radius: 10px;
}

.el-alert--warning {
  margin: 8px 0;
}

.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.el-checkbox-group .el-checkbox {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/directpkg.vue